import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import editableCell from "@/pages/productmanager/components/editableCell.vue";
import { TreeSelect } from "ant-design-vue";
import product_default from "@/assets/img/product_default.png";
import pic from "@/assets/test.png";
import Sortable from "sortablejs";
import { updateCategoryIndex } from "@/services/product/category";
import { designSearchProduct } from "@/services/design";
import { request, METHOD } from "@/utils/request";
var timeout;
var currentValue;
function search(value, cb) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  function fake() {
    var data = {
      clientType: 1,
      langId: 2,
      type: 1,
      productBrandidStr: "",
      productSourceareaidStr: "",
      transportIdStr: "",
      productClassifyId: "",
      page: 1,
      size: 100,
      totalCount: 0,
      sort: 0,
      rand: "",
      searchKeyWord: value
    };
    designSearchProduct(data).then(function (res) {
      return res.data;
    }).then(function (res) {
      if (currentValue === value) {
        cb(res.data.productList);
      }
    });
  }
  timeout = setTimeout(fake, 300);
}
export default {
  name: "goods-source-manager",
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    visible: {
      visible: Boolean,
      default: false
    }
  },
  i18n: require('../../design_i18n'),
  data: function data() {
    var columns = [{
      dataIndex: "productNo",
      key: "productNo",
      slots: {
        title: "productNoSlots"
      },
      scopedSlots: {
        customRender: "productNoScopedSlots"
      },
      width: "10%"
    }, {
      title: this.$t("com.productName"),
      dataIndex: "productName",
      key: "productName",
      scopedSlots: {
        customRender: "productNameScopedSlots"
      },
      width: "45%"
    }, {
      title: this.$t('com.stockNumTitle'),
      dataIndex: 'productStockNum',
      key: 'productStockNum',
      width: "10%"
    }, {
      title: this.$t('form.status'),
      dataIndex: "productStatus",
      key: "productStatus",
      width: "10%",
      scopedSlots: {
        customRender: "productStatus"
      }
    }, {
      title: this.$t("com.operation"),
      key: "operation",
      scopedSlots: {
        customRender: "operation"
      },
      width: "15%"
    }];
    this.lastFetchId = 0;
    this.fetchData = _.debounce(this.fetchData, 300);
    return {
      // 是否展示
      /* visible: false, */
      loading: false,
      columns: columns,
      /* innerColumns, */
      searchData: [],
      searchValue: undefined,
      leftCurrencySymbol: localStorage.getItem("leftCurrencySymbol"),
      rightCurrencySymbol: localStorage.getItem("rightCurrencySymbol"),
      productList: this.value,
      goods_list: this.value,
      classifyList: this.value,
      fetching: false
    };
  },
  watch: {
    value: function value(newValue) {
      this.goods_list = newValue;
    }
  },
  computed: {
    totalNum: function totalNum() {
      return this.goods_list.length;
    },
    isTop: function isTop() {
      return function (r) {
        var index = 0;
        this.value.forEach(function (x, i) {
          if (x.productNo == r.productNo) {
            index = i;
          }
        });
        return index === 0 ? true : false;
      };
    },
    isBottom: function isBottom() {
      return function (r) {
        var index = 0;
        this.value.forEach(function (x, i) {
          if (x.productNo == r.productNo) {
            index = i;
          }
        });
        return index === this.value.length - 1 ? true : false;
      };
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.setSort();
    });
  },
  methods: {
    fetchData: function fetchData(value) {
      var _this2 = this;
      this.lastFetchId += 1;
      var fetchId = this.lastFetchId;
      this.searchData = [];
      this.fetching = true;
      fake(value, function (data) {
        if (fetchId !== _this2.lastFetchId) {
          // todo
          return;
        }
        _this2.searchData = data;
        _this2.fetching = false;
      });
    },
    handleAdd: function handleAdd() {
      var _this3 = this;
      var self = this;
      if (!this.searchValue) {
        this.$message.error(this.$t('com.placeSearchAdd'));
        return;
      }
      var alreadyGoods = self.value.filter(function (item) {
        return item && item.productSpecificationId == self.searchValue;
      });
      if (alreadyGoods.length > 0) {
        self.$message.error(this.$t('com.alreadyInGoodsList'));
        return;
      }
      var item = this.searchData.filter(function (item) {
        return item.productSpecificationId == _this3.searchValue;
      });
      if (!item.length) {
        this.$message.error(this.$t('com.addError'));
        return "";
      }
      this.value.unshift(item[0]);
      this.$emit("add", item[0]);
      this.$message.success(this.$t('com.addSuccess'));
    },
    handleSearch: function handleSearch(value) {
      var _this4 = this;
      this.fetching = true;
      this.searchData = [];
      search(value, function (data) {
        _this4.searchData = data;
        _this4.fetching = false;
      });
    },
    handleChange: function handleChange(value) {
      this.searchValue = value;
    },
    handleDeleteGoods: function handleDeleteGoods(r) {
      this.$emit("delete", r);
    },
    handleTopGoods: function handleTopGoods(r) {
      var index = 0;
      this.value.forEach(function (x, i) {
        if (x.productNo == r.productNo) {
          index = i;
        }
      });
      var targetRow = this.value.splice(index, 1)[0];
      this.value.unshift(targetRow);
      this.$message.success(this.$t('com.topSuccess'));
    },
    handleBottomGoods: function handleBottomGoods(r) {
      var index = 0;
      this.value.forEach(function (x, i) {
        if (x.productNo == r.productNo) {
          index = i;
        }
      });
      var targetRow = this.value.splice(index, 1)[0];
      this.value.push(targetRow);
      this.$message.success(this.$t('com.bottomSuccess'));
    },
    handleTableMounted: function handleTableMounted() {

      /* this.setSort() */
    },
    setSort: function setSort() {
      var _this5 = this;
      var el = document.querySelectorAll(".ant-table-body > table > tbody")[0];
      this.sortable = Sortable.create(el, {
        ghostClass: "sortable-ghost",
        setData: function setData(dataTransfer) {
          dataTransfer.setData("Text", "");
        },
        onEnd: function onEnd(evt) {
          var targetRow = _this5.value.splice(evt.oldIndex, 1)[0];
          _this5.value.splice(evt.newIndex, 0, targetRow);
          _this5.$message.success(_this5.$t('com.sortSuccess'));
          /* this.$emit('input', this.classifyList) */
          // //重新设置序号
          // let processorderDatalist = [];
          // for (var i = 0; i < this.classifyList.length; i++) {
          //   let processorderData = new Object();
          //   processorderData.id = this.classifyList[i].id + "";
          //   processorderData.categoryName = this.classifyList[i].categoryName
          //   processorderData.productQuantity = this.classifyList[i].productQuantity
          //   processorderData.lastUpdatedTime = this.classifyList[i].lastUpdatedTime
          //   processorderData.showFlag = this.classifyList[i].showFlag + "";
          //   processorderData.parentId = this.classifyList[i].parentId + "";
          //   processorderData.sortIndex = i + 1 + "";
          //   processorderDatalist.push(processorderData);
          // }
          // // 调用接口，将变换后的顺序进行保存
          // updateCategoryIndex(processorderDatalist).then(response => {
          //   if (response.data.code == 200) {
          //     this.$message.success(this.$t('public.updateSuccessfully'));
          //     //如果拖拽排序的是所有分类，那么需要刷新左侧的列表
          //     if (this.defaultSelectedKeys[0] == 0) {
          //       this.getLfetList()
          //     } else {
          //       //刷新右侧的树形结构
          //       this.getRightList(this.selectedKeys[0])
          //     }
          //   }
          // })
        }
      });
    },
    //点击删除的时候，不关闭
    handleMenuClick: function handleMenuClick(record) {
      record.deleteVisible = true;
    },
    /* handleDeleteSelectedGoods() {
      *     let arr = _.cloneDeep(this.goods_list);
        *   this.selectedRowKeys.forEach((pno) => {
        *     arr.forEach((item, i) => {
      *       if (item.productNo === pno ) {
      *         arr.splice(i, 1)
      *       }
      *     })
      *   });
      *   
      *   this.selectedRowKeys = [];
      *   this.goods_list = [...arr];
      *   // this.$emit('input', this.goods_list)
      * }, */
    /**
     * 打开弹窗
     * @param {Array} list 商品列表
     */
    show: function show() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.visible = true;
      this.goods_list = _toConsumableArray(list);
      this.classifyList = this.goods_list;
    },
    /**
     * 删除商品
     */
    handleRemoveItem: function handleRemoveItem(row) {
      this.goods_list = this.goods_list.filter(function (x) {
        return x.goods_sn != row.goods_sn;
      });
    },
    /**
     * 弹窗按钮 - 确认
     */
    handleConfirm: function handleConfirm() {
      this.$emit("confirm", this.goods_list);
      this.$emit("update:visible", false);
    },
    /**
     * 弹窗按钮 - 取消
     */
    handleCancel: function handleCancel() {
      this.$emit("update:visible", false);
    },
    /**
     * 打开数据源
     */
    openSource: function openSource() {
      var skus = this.goods_list.map(function (x) {
        return x.goods_sn;
      });
      this.$refs.goodsManager.show(skus);
    },
    /**
     * 更新商品列表
     */
    update_goods_list: function update_goods_list(list) {
      var arr = [].concat(_toConsumableArray(this.goods_list), _toConsumableArray(list));
      this.goods_list = arr;
    }
  }
};